import { AlertsV2Service } from '@/services/alerts-v2-service'
import { nextTick, ref } from 'vue'
import type {
  SwapAlertsFilter,
  SwapAlertResponse,
  SwapAlertSortingKey,
  SwapAlertsResponse,
} from '@/services/alerts-v2-service/types'
import { createAlertsBase } from './factories/alertsFactory'
import { defineStore } from 'pinia'
import type { FetchOptions } from '@/utils/types'
import axios from 'axios'
import { FALLBACK_API_ERROR } from '@/utils/consts'

export const useSwapAlertsStore = defineStore('swap-alerts', () => {
  const alertsBase = createAlertsBase<
    SwapAlertResponse,
    SwapAlertsResponse,
    SwapAlertsFilter,
    SwapAlertSortingKey
  >({ sortBy: 'spread' }, AlertsV2Service.fetchSwap)

  const fakeRowsCount = ref(15)
  const isSpot = ref(true)
  const isSpotSell = ref(false)
  const wsEnabled = ref(false)

  const init = (isSpotValue: boolean, isSpotSellValue: boolean) => {
    alertsBase.loading.value = true
    isSpot.value = isSpotValue
    isSpotSell.value = isSpotSellValue
    wsEnabled.value = false
    // Синхронизируем is_spot / is_spot_sell в filters, чтобы WebSocket подхватывал их автоматически
    alertsBase.filters.value = {
      ...(alertsBase.filters.value || {}),
      is_spot: isSpotValue,
      is_spot_sell: isSpotSellValue,
    } as SwapAlertsFilter
  }
  const sort = (sortByValue: string, sortOrderValue: number) => {
    alertsBase.sortBy.value = sortByValue as SwapAlertSortingKey
    alertsBase.sortOrder.value = sortOrderValue
  }

  const fetch = async (page: number, opts: FetchOptions = {}) => {
    alertsBase.page.value = page

    if (!opts.keepState) {
      alertsBase.loading.value = true
    }

    // Если WS уже работает — пропускаем HTTP-запрос, данные придут через сокет
    if (wsEnabled.value) {
      return
    }

    const filtersToSend = {
      ...alertsBase.filters.value,
    } as SwapAlertsFilter
    filtersToSend.is_spot = isSpot.value
    filtersToSend.is_spot_sell = isSpotSell.value

    try {
      const req = await AlertsV2Service.fetchSwap(
        page,
        filtersToSend,
        alertsBase.sortBy.value as SwapAlertSortingKey,
        alertsBase.sortOrder.value == -1 ? 'desc' : 'asc',
      )
      const data = req.data as SwapAlertsResponse
      alertsBase.alerts.value = data.alerts
      alertsBase.pages.value = data.pages
      alertsBase.pageSize.value = data.page_size
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        alertsBase.error.value = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        alertsBase.error.value = FALLBACK_API_ERROR
      }
    } finally {
      alertsBase.loading.value = false
    }
  }

  const updateFromWs = (data: SwapAlertsResponse) => {
    console.log(
      '[swapStore updateFromWs] called, alerts:',
      data?.alerts?.length,
      'pages:',
      data?.pages,
    )
    wsEnabled.value = true
    alertsBase.alerts.value = data.alerts
    alertsBase.pages.value = data.pages
    alertsBase.pageSize.value = data.page_size
    nextTick(() => {
      alertsBase.loading.value = false
    })
    console.log('[swapStore updateFromWs] loading set to false')
  }

  return {
    ...alertsBase,
    init,
    sort,
    fetch,
    updateFromWs,
    wsEnabled,
    fakeRowsCount,
    isSpot,
    isSpotSell,
  }
})
